import { render, staticRenderFns } from "./ScoolfolioDialog.vue?vue&type=template&id=4c665a44&scoped=true&"
import script from "@/views/Users/Student/ScoolfolioDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/ScoolfolioDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/scoolfolio-dialog.scss?vue&type=style&index=0&id=4c665a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c665a44",
  null
  
)

export default component.exports